import React from "react";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";

const ToolWorkspace = ({
  label,
  title,
  subtitle,
  sampleHref,
  sampleName,
  children,
}) => {
  return (
    <main className="relative min-h-[calc(100vh-72px)] overflow-hidden bg-brand-surface">
      <div
        className="pointer-events-none absolute -left-24 top-10 h-72 w-72 animate-soft-pulse rounded-full bg-[radial-gradient(circle,rgba(23,191,158,0.18),transparent_70%)]"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute -right-20 bottom-0 h-80 w-80 animate-soft-pulse rounded-full bg-[radial-gradient(circle,rgba(10,43,30,0.08),transparent_72%)]"
        aria-hidden="true"
      />

      <section className="relative py-10 md:py-14">
        <Container>
          <div className="mb-8 animate-fade-up">
            <Link
              to="/divein"
              className="mb-5 inline-flex items-center gap-1.5 font-display text-sm font-semibold text-brand-teal-dark no-underline transition hover:text-brand-forest"
            >
              <i className="ri-arrow-left-line" />
              Back to tools
            </Link>

            <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
              <div className="max-w-[560px]">
                <p className="section-label">{label}</p>
                <h1 className="mb-2 font-display text-[clamp(1.85rem,3.5vw,2.6rem)] font-extrabold tracking-tight text-brand-forest">
                  {title}
                </h1>
                {subtitle && (
                  <p className="m-0 text-[1.02rem] leading-relaxed text-brand-muted">
                    {subtitle}
                  </p>
                )}
              </div>

              {sampleHref && (
                <a
                  href={sampleHref}
                  download={sampleName}
                  className="inline-flex shrink-0 items-center gap-2 rounded-full border border-brand-forest/12 bg-white px-4 py-2.5 font-display text-sm font-semibold text-brand-forest no-underline transition hover:border-brand-teal/40 hover:bg-brand-soft/70"
                >
                  <i className="ri-download-2-line text-brand-teal-dark" />
                  Sample image
                </a>
              )}
            </div>
          </div>

          <div className="animate-fade-up-1 rounded-[22px] border border-brand-forest/10 bg-white p-5 shadow-brand sm:p-7 md:p-8">
            {children}
          </div>

          <div className="mt-6 animate-fade-up-2">
            <Link to="/feedback" className="btn no-underline">
              Send feedback
            </Link>
          </div>
        </Container>
      </section>
    </main>
  );
};

export default ToolWorkspace;
